// NOTE this file contains the internal dependencies of @lvflanders BAR modules
// we use this to avoid having to break whenever a new version is used
// UMD bundles from ngx-packagr through Angular Libraries doesn't bundle this code (because not possible or too difficult)
import * as localforage from "localforage";
import * as postscribe from "postscribe";
import * as signalr from "@microsoft/signalr";
import * as lit from "lit";
import * as litDecorators from "lit/decorators.js";
import axios from "axios";

// global glue variable for externals
window["localforage"] = localforage;
window["postscribe"] = postscribe;
window["microsoft"] = { signalr };
window["lit"] = lit;
window["lit/decorators.js"] = litDecorators;
window["lit/decorators"] = litDecorators;
window["axios"] = axios;

export { localforage, postscribe, signalr, lit, litDecorators, axios };
